module.exports = __webpack_public_path__ + "static/media/How to customize email link template for simple Email Notification.e3ca51c3.png";